import Swiper, { A11y, Navigation, Pagination } from 'swiper';

class mPdCarrouselPackshots extends HTMLDivElement {
    constructor() {
        super();
        this.slider = null;
    }

    connectedCallback() {
        this.initSlider();
    }

    disconnectedCallback() {}

    initSlider() {
        const sliderEl = this.querySelector('.swiper-container');

        this.slider = new Swiper(sliderEl, {
            modules: [A11y, Navigation, Pagination],
            slidesPerView: 1,
            allowTouchMove: true,
            loop: true,
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev')
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets'
            }
        });
    }
}

customElements.define('m-pd-carrousel-packshots', mPdCarrouselPackshots, {
    extends: 'div'
});
